import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiLinkedin, FiInstagram, FiFacebook, FiArrowRight } from "react-icons/fi";
import "./Footer.css";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="footer">
      <div className="container footer__top">
        <div className="footer__brand">
          <img src="/edgelogo.png" alt="Edge Tech Logo" className="navbar__logo-image" />
          {/* <span className="footer__logo">
            EDGE<span className="footer__logo-accent">Tech</span>
          </span> */}
          <p className="footer__tagline">
            Engineering tomorrow's technology today — AI, robotics, and
            automation systems built for industrial-grade reliability.
          </p>
          <div className="footer__socials">
            <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <FiLinkedin />
            </a>
            <a href="https://www.instagram.com/edgetechacademy?igsh=MXdvYjlxNThjMzU3ag%3D%3D&utm_source=qr" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FiInstagram />
            </a>
            <a href="https://www.facebook.com/share/1BiAFGsf8U/?mibextid=LQQJ4d" aria-label="Facebook" target="_blank" rel="noreferrer">
              <FiFacebook />
            </a>
          </div>
        </div>

        <div className="footer__col">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer__col">
          <h4>Services</h4>
          <Link to="/services">AI & Machine Intelligence</Link>
          <Link to="/services">Industrial Automation</Link>
          <Link to="/services">Robotics & Motion Systems</Link>
          <Link to="/services">Cloud & Edge Platforms</Link>
        </div>

        <div className="footer__col">
          <h4>Contact</h4>
          <a href="tel:+919500128037">95001 28037</a>
          {/* <a href="tel:+919500128037">95001 28060</a>
          <a href="tel:+919567779890">95677 79890</a> */}
          <a href="mailto:hello@edgeTech.io">hello@edgeTech.io</a>
          <span>Bypass Road, Sekharipuram, Kalpathy, Palakkad, Kerala 678003</span>
        </div>

        <div className="footer__col footer__newsletter">
          <h4>Newsletter</h4>
          <p>Engineering insights, once a month. No noise.</p>
          <form onSubmit={handleSubscribe} className="footer__form">
            <input
              type="email"
              required
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email address"
            />
            <button type="submit" aria-label="Subscribe">
              <FiArrowRight />
            </button>
          </form>
          {subscribed && <span className="footer__subscribed">You're subscribed — thank you.</span>}
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <span>© {new Date().getFullYear()} Edge Tech. All rights reserved.</span>
          <div className="footer__legal">
            <Link to="/contact">Privacy Policy</Link>
            <Link to="/contact">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
